import { Connector } from './connector.model';
import { Image } from './image.model';
import { StationGroup } from './station-group';

export class Station {
  ID: string;
  Name: string;
  OwnerId: number;
  OwnerUsername: string;
  Description: string;
  Address: string;
  Latitude: number;
  Longitude: number;
  IsDisabled: boolean;
  StationGroups: StationGroup[];
  CanBeManaged: boolean;
  Connectors: Connector[];
  Images: Image[];
  ActivePower: number;
  State: number;
}
